import { type ImageRendererState } from './image-renderer.react';
type ActionData = {
  payload?: {
    x?: number;
    y?: number;
    xMovement?: number;
    yMovement?: number;
  };
  type: string;
};
export const reducer = (state: ImageRendererState, action: ActionData) => {
  switch (action.type) {
    case 'ON_ZOOM_IN':
      {
        const newScale = Math.min(state.scale + 0.25, state.maxScale);
        return {
          ...state,
          scale: newScale
        };
      }
    case 'ON_ZOOM_OUT':
      {
        const newScale = Math.max(state.scale - 0.25, state.minScale);
        return {
          ...state,
          scale: newScale
        };
      }
    case 'ON_ZOOM_FIT':
      {
        return {
          ...state,
          scale: 1,
          offsets: {
            x: 0,
            y: 0
          }
        };
      }
    case 'ON_IMG_ROTATE':
      {
        return {
          ...state,
          img: {
            ...state.img,
            rotation: (state.img.rotation + 90) % 360
          }
        };
      }
    case 'ON_MOUSE_DOWN':
      {
        if (!action.payload) {
          return state;
        }
        return {
          ...state,
          enablePan: true
        };
      }
    case 'ON_MOUSE_UP':
      {
        return {
          ...state,
          enablePan: false
        };
      }
    case 'ON_MOUSE_MOVE':
      {
        if (!action.payload) {
          return state;
        }
        const newOffsets = state.enablePan ? {
          // @ts-expect-error missing null check
          x: state.offsets.x + action.payload.xMovement,
          // @ts-expect-error missing null check
          y: state.offsets.y + action.payload.yMovement
        } : state.offsets;
        return {
          ...state,
          offsets: newOffsets
        };
      }
    case 'RESET_EXPANDED':
      {
        return {
          ...state,
          scale: 1,
          expanded: false,
          offsets: {
            x: 0,
            y: 0
          }
        };
      }
    case 'ON_EXPAND_TOGGLE':
      {
        return {
          ...state,
          scale: 1,
          expanded: !state.expanded,
          offsets: {
            x: 0,
            y: 0
          }
        };
      }
    case 'ON_OCR':
      {
        return {
          ...state,
          expanded: true,
          img: {
            ...state.img
          }
        };
      }
    default:
      {
        return state;
      }
  }
};